import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { Toolbar } from "primereact/toolbar";
import { classNames } from "primereact/utils";
import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
  useTransition,
  useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Hamburger from "hamburger-react";
import { logout, switchUser } from "../../../store/slices/AuthSlice";
import SharedConfirmDialog from "../../../components/Shared/SharedConfirmDialog";
import LangSwitcher from "../../../components/Shared/LangSwitcher";
import { getBranches } from "../../../store/slices/BusinessSlice";
import Spinner from "../../../components/Shared/Spinner";
import ProfileDropdown from "./ProfileDropdown";
import { CurrentVersion } from "../../../config";
import {
  MdArrowDropDown,
  MdOutlineDashboard,
  MdOutlineLibraryBooks,
  MdOutlinePayment,
} from "react-icons/md";
import { GoGlobe } from "react-icons/go";
import { AiOutlineBranches } from "react-icons/ai";
import { FiUsers, FiFileText } from "react-icons/fi";
import {
  FaMoneyBill,
  FaMoneyCheck,
  FaBoxOpen,
  FaBoxes,
  FaRegUserCircle,
  FaRegBuilding,
  FaStoreAlt,
  FaMoneyCheckAlt,
  FaRegChartBar,
  FaUserShield,
  FaFileInvoiceDollar,
  FaFileInvoice,
  FaCreditCard,
  FaBuilding,
  FaCashRegister,
  FaBriefcase,
  FaShoppingCart,
  FaCog,
  FaHome,
} from "react-icons/fa";
import { PiInvoice, PiReceipt } from "react-icons/pi";
import { TbAdjustmentsHorizontal, TbReportAnalytics } from "react-icons/tb";
import { LuScrollText } from "react-icons/lu";
import {
  BiPurchaseTagAlt,
  BiVerticalCenter,
  BiNetworkChart,
} from "react-icons/bi";
import { IoReceiptOutline, IoTicketOutline } from "react-icons/io5";

import { makeEntry } from "../../../components/Shared/MakeEntry";
import { isActivePath } from "../sideBar/SideBar";

export const menu = (t, navigate) => [
  {
    ...makeEntry(
      "dashboard",
      "/manager/dashboard",
      MdOutlineDashboard,
      15,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "Dashboard",
        "/manager/dashboard",
        MdOutlineDashboard,
        15,
        "",
        t,
        navigate,
      ),
    ],
  },
  {
    ...makeEntry(
      "chartofaccount",
      "/manager/accounts",
      FaRegChartBar,
      15,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "chartofaccount",
        "/manager/accounts",
        FaRegChartBar,
        15,
        "",
        t,
        navigate,
      ),
    ],
  },
  {
    ...makeEntry(
      "journalentries",
      "/manager/transactions",
      MdOutlineLibraryBooks,
      15,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "journalentries",
        "/manager/transactions",
        MdOutlineLibraryBooks,
        15,
        "",
        t,
        navigate,
      ),
    ],
  },
  // {
  //   ...makeEntry(
  //     "Journal Ledger",
  //     "/manager/journal-ledger",
  //     MdOutlineLibraryBooks,
  //     15,
  //     "text-white",
  //     t,
  //     navigate,
  //   ),
  //   children: [
  //     makeEntry(
  //       "Journal Ledger",
  //       "/manager/journal-ledger",
  //       MdOutlineLibraryBooks,
  //       15,
  //       "",
  //       t,
  //       navigate,
  //     ),
  //   ],
  // },
  {
    ...makeEntry(
      "invoices",
      "/manager/invoices",
      FaFileInvoiceDollar,
      16,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "sales invoice",
        "/manager/invoices",
        FaFileInvoiceDollar,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "company invoice",
        "/manager/insuranceInvoice",
        FaBuilding,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "insurance claim invoice",
        "/manager/insurance-claim-invoice",
        MdOutlinePayment,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "credit invoice",
        "/manager/creditInvoiceTable",
        FaCreditCard,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "credit company invoice",
        "/manager/creditCompanyInvoiceTable",
        FaBriefcase,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "credit claim invoice",
        "/manager/credit-claim-invoice",
        FaFileInvoice,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "POS",
        "/zatca/thirdparty",
        FaCashRegister,
        16,
        "",
        t,
        navigate,
      ),
    ],
  },
  // {
  //   ...makeEntry(
  //     'hisinvoices',
  //     '/manager/his-cash-invoices',
  //     FaFileInvoiceDollar,
  //     16,
  //     'text-white',
  //     t,
  //     navigate
  //   ),
  //   children: [
  //     makeEntry(
  //       'cash invoice',
  //       '/manager/his-cash-invoices',
  //       FaFileInvoiceDollar,
  //       16,
  //       '',
  //       t,
  //       navigate
  //     ),
  //     makeEntry(
  //       'company invoice',
  //       '/manager/his-company-invoices',
  //       FaBuilding,
  //       16,
  //       '',
  //       t,
  //       navigate
  //     ),
  //     makeEntry(
  //       'credit notes',
  //       '/manager/his-credit-notes',
  //       FaBriefcase,
  //       16,
  //       '',
  //       t,
  //       navigate
  //     ),
  //     makeEntry(
  //       'credit company notes',
  //       '/manager/his-credit-company-notes',
  //       FaFileInvoice,
  //       16,
  //       '',
  //       t,
  //       navigate
  //     ),
  //     makeEntry(
  //       'deposit invoice',
  //       '/manager/his-deposit-invoices',
  //       FaFileInvoice,
  //       16,
  //       '',
  //       t,
  //       navigate
  //     ),
  //     makeEntry(
  //       'Daily Invoice Report',
  //       '/manager/his-daily-invoice-report',
  //       FaMoneyBill,
  //       16,
  //       '',
  //       t,
  //       navigate
  //     ),
  //   ]
  // },
  {
    ...makeEntry(
      "configuration",
      "/manager/customers",
      FaCog,
      16,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "customers",
        "/manager/customers",
        FaRegUserCircle,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "insurance company",
        "/manager/business",
        FaBriefcase,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "branches",
        "/manager/branch",
        AiOutlineBranches,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "cost centers",
        "/manager/costCenter",
        BiNetworkChart,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "payment Methods",
        "/manager/payment/methods",
        FaCreditCard,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry("TPA", "/manager/tpa", FaUserShield, 16, "", t, navigate),
      makeEntry("Settings", "/manager/settings", FaCog, 16, "", t, navigate),
    ],
  },
  {
    ...makeEntry(
      "Payroll",
      "/manager/payroll",
      LuScrollText,
      15,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "Payroll",
        "/manager/payroll",
        LuScrollText,
        15,
        "",
        t,
        navigate,
      ),
    ],
  },
  {
    ...makeEntry(
      "Supply Chain",
      "/manager/erp/purchasing-stats",
      FaBoxes,
      16,
      "text-white",
      t,
      navigate,
    ),
    children: [
      // makeEntry("ERP Dashboard", "/manager/erp/dashboard", MdOutlineDashboard, 16, "", t, navigate),
      makeEntry("Purchasing Dashboard", "/manager/erp/purchasing-stats", TbReportAnalytics, 16, "", t, navigate),
      makeEntry("Items", "/manager/erp/items", FaBoxOpen, 16, "", t, navigate),
      makeEntry("Suppliers", "/manager/erp/suppliers", FaStoreAlt, 16, "", t, navigate),
      makeEntry("Purchase Invoices", "/manager/erp/purchase-invoices", FaFileInvoiceDollar, 16, "", t, navigate),
      makeEntry("Sale Invoices", "/manager/erp/sale-invoices", FaFileInvoice, 16, "", t, navigate),
    ],
  },
  {
    ...makeEntry(
      "purchase",
      "/manager/items",
      BiPurchaseTagAlt,
      15,
      "text-white",
      t,
      navigate,
    ),

    children: [
      makeEntry("items", "/manager/items", FaBoxOpen, 16, "", t, navigate),
      makeEntry("vendor", "/manager/vendor", FaStoreAlt, 16, "", t, navigate),
      makeEntry(
        "purchased entry",
        "/manager/purchased_entry",
        FaShoppingCart,
        16,
        "",
        t,
        navigate,
      ),
    ],
  },
  {
    ...makeEntry(
      "voucher",
      "/manager/payment/voucher",
      MdOutlinePayment,
      16,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "payment voucher",
        "/manager/payment/voucher",
        MdOutlinePayment,
        16,
        "",
        t,
        navigate,
      ),
      makeEntry(
        "receipt voucher",
        "/manager/receipt/voucher",
        IoReceiptOutline,
        16,
        "",
        t,
        navigate,
      ),
    ],
  },
  {
    ...makeEntry(
      "reports",
      "/manager/report",
      TbReportAnalytics,
      17,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "reports",
        "/manager/report",
        TbReportAnalytics,
        17,
        "",
        t,
        navigate,
      ),
    ],
  },
];

export const cashierMenu = (t, navigate) => [
  {
    ...makeEntry(
      "Point of Sale",
      "/zatca/thirdparty",
      FiUsers,
      17,
      "text-white",
      t,
      navigate,
    ),
    children: [
      makeEntry(
        "Point of Sale",
        "/zatca/thirdparty",
        FiUsers,
        17,
        "",
        t,
        navigate,
      ),
    ],
  },
];
export let WHerToLogin;

export default function Navbar({
  setNavMenuOpen,
  navMenuOpen,
  childrens,
  setChildrens,
}) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const profileMenu = useRef()
  const branchMenu = useRef();
  const navMenu = useRef();
  const dropdownRef = useRef(null);
  const { isLoading } = useSelector((state) => state.auth);
  const [navMenuArray, setNavMenurray] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const { branches } = useSelector((state) => state.business);
  const [logoutConfirm, setLogoutConfirm] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showBranchMenu, setShowBranchMenu] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);

  useOutsideClickHandler(dropdownRef, () => setShowList(false));
  function useOutsideClickHandler(ref, callback) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, callback]);
  }
  useEffect(() => {
    dispatch(getBranches());
  }, []);
  const endContent = (
    <Fragment>
      <div className="flex gap-2 px-2 items-center !py-1 !shadow-none">
        <div
          className="block md:hidden"
          onClick={(e) => {
            setNavMenuOpen(!navMenuOpen);
            navMenu?.current?.toggle(e);
          }}
        >
          <Hamburger toggled={navMenuOpen} color="#000000" />
        </div>
        {user?.branch_id && branches?.data && (
          <div className="flex items-center gap-2 bg-green-500 text-white px-3 py-1.5 rounded-md shadow-sm">
            <FaHome size={16} />
            <span className="text-sm font-medium">
              {i18n.language === "ar"
                ? Object.values(branches.data).find(
                  (b) => b?.id === user?.branch_id,
                )?.name_ar ||
                Object.values(branches.data).find(
                  (b) => b?.id === user?.branch_id,
                )?.name_en ||
                t("Branch")
                : Object.values(branches.data).find(
                  (b) => b?.id === user?.branch_id,
                )?.name_en ||
                Object.values(branches.data).find(
                  (b) => b?.id === user?.branch_id,
                )?.name_ar ||
                t("Branch")}
            </span>
          </div>
        )}
        <div className="flex items-center justify-start gap-3 ">
          <LangSwitcher />
        </div>

        <div
          onClick={(e) => branchMenu?.current?.toggle(e)}
          className="flex items-center gap-2 cursor-pointer !h-[26px] bg-gray-500 text-white px-2.5 !py-1.5 rounded-md transition-all"
        >
          {isLoading || isSwitching ? (
            <Spinner fill="#ffffff" />
          ) : (
            <AiOutlineBranches size={16} />
          )}
          <span className="text-sm font-medium">{t("Switch")}</span>
        </div>
        <ProfileDropdown />
      </div>
      <Menu
        model={[
          ...(branches?.data && Object.values(branches.data).length > 0
            ? Object.values(branches.data)
              .filter((branch) => branch && branch.id)
              .sort((a, b) => {
                const userBranchId = user?.branch_id;
                if (!userBranchId) return 0;
                if (a?.id === userBranchId) return -1;
                if (b?.id === userBranchId) return 1;
                return 0;
              })
              .map((branch, index) => {
                if (!branch || !branch.id) return null;

                const isCurrentBranch =
                  user?.branch_id && branch.id === user.branch_id;
                const branchLabel =
                  i18n.language === "ar"
                    ? branch.name_ar || branch.name_en || "Unknown Branch"
                    : branch.name_en || branch.name_ar || "Unknown Branch";

                return {
                  label: branchLabel,
                  icon: isCurrentBranch
                    ? "pi pi-check-circle"
                    : "pi pi-building",
                  command: async () => {
                    if (isSwitching || isCurrentBranch || !branch?.id) {
                      return;
                    }
                    setIsSwitching(true);
                    try {
                      const res = await dispatch(
                        switchUser({ branch_id: branch.id }),
                      );
                      if (res.meta.requestStatus === "fulfilled") {
                        setTimeout(() => {
                          window.location.href = "/manager/dashboard";
                        }, 500);
                      } else {
                        setIsSwitching(false);
                      }
                    } catch (error) {
                      console.error("Switch failed:", error);
                      setIsSwitching(false);
                    }
                    setTimeout(() => setIsSwitching(false), 5000);
                  },
                  className: isCurrentBranch ? "current-branch" : "",
                  template: (item, options) => {
                    if (!item) return null;

                    return (
                      <button
                        onClick={(e) => options?.onClick?.(e)}
                        className={classNames(
                          options?.className || "",
                          "w-full p-link flex items-center py-2 px-3 text-color rounded-none",
                          isCurrentBranch
                            ? "bg-gray-200 font-medium"
                            : "hover:bg-gray-100",
                        )}
                        disabled={isCurrentBranch}
                      >
                        <i
                          className={`${item.icon || "pi pi-building"} mr-2`}
                        ></i>
                        <span className="flex-1 text-left">
                          {item.label || "Branch"}
                        </span>
                        {isCurrentBranch && (
                          <span className="text-xs ml-2">
                            ({t("Current")})
                          </span>
                        )}
                      </button>
                    );
                  },
                };
              })
              .filter(Boolean)
            : []),
        ]}
        popup
        ref={branchMenu}
        id="popup_branch_menu"
        className="!bg-white text-black border border-gray-200 shadow-lg custom-menu"
        pt={{
          label: { className: "text-black" },
          content: { className: `!bg-white` },
          icon: { className: "text-gray-700" },
        }}
        style={{ width: "16rem" }}
      />
    </Fragment>
  );

  return (
    <nav
      className={`flex bg-white h-[50px] w-full items-center md:px-4 px-4 relative  justify-between`}
    >
      <div className="flex items-center md:ml-[5px]">
        <div
          className="block md:hidden me-3"
          onClick={(e) => {
            setNavMenuOpen(!navMenuOpen);
          }}
        >
          <Hamburger toggled={navMenuOpen} color="#0070C2" size={20} />
        </div>
        <div className="flex gap-2 justify-center items-center">
          <img
            src="/images/supergit-03.png"
            className="w-10 cursor-pointer lg:w-10"
            alt="SuperGIT"
          />
          <span className="text-18-dark whitespace-nowrap">
            {t("SuperGitv2.1.4")} {CurrentVersion}
          </span>
        </div>
      </div>

      <div
        className={`flex gap-2 items-center justify-end ${i18n.language === "en" ? "ml-auto" : "mr-auto"}`}
      >
        <div className={`flex items-center justify-end w-full gap-2`}>
          {user?.branch_id && branches?.data && (
            <div className="flex items-center gap-2 bg-green-500 text-white px-3 py-1.5 rounded-md shadow-sm ">
              <FaHome size={16} />
              <span className="text-sm font-medium">
                {i18n.language === "ar"
                  ? Object.values(branches.data).find(
                    (b) => b?.id === user?.branch_id,
                  )?.name_ar ||
                  Object.values(branches.data).find(
                    (b) => b?.id === user?.branch_id,
                  )?.name_en ||
                  t("Branch")
                  : Object.values(branches.data).find(
                    (b) => b?.id === user?.branch_id,
                  )?.name_en ||
                  Object.values(branches.data).find(
                    (b) => b?.id === user?.branch_id,
                  )?.name_ar ||
                  t("Branch")}
              </span>
            </div>
          )}
          <LangSwitcher />

          <div
            onClick={(e) => branchMenu?.current?.toggle(e)}
            className="flex items-center gap-2 cursor-pointer  bg-gray-500 text-white px-2.5 !py-1.5 rounded-md transition-all"
          >
            {isLoading || isSwitching ? (
              <Spinner fill="#ffffff" />
            ) : (
              <AiOutlineBranches size={16} />
            )}
            <span className="text-sm font-medium">{t("Switch")}</span>
          </div>

          <ProfileDropdown />
        </div>
      </div>

      {/* Menus for Branch Switcher */}
      <Menu
        model={[
          ...(branches?.data && Object.values(branches.data).length > 0
            ? Object.values(branches.data)
              .filter((branch) => branch && branch.id)
              .sort((a, b) => {
                const userBranchId = user?.branch_id;
                if (!userBranchId) return 0;
                if (a?.id === userBranchId) return -1;
                if (b?.id === userBranchId) return 1;
                return 0;
              })
              .map((branch, index) => {
                if (!branch || !branch.id) return null;

                const isCurrentBranch =
                  user?.branch_id && branch.id === user.branch_id;
                const branchLabel =
                  i18n.language === "ar"
                    ? branch.name_ar || branch.name_en || "Unknown Branch"
                    : branch.name_en || branch.name_ar || "Unknown Branch";

                return {
                  label: branchLabel,
                  icon: isCurrentBranch
                    ? "pi pi-check-circle"
                    : "pi pi-building",
                  command: async () => {
                    if (isSwitching || isCurrentBranch || !branch?.id) {
                      return;
                    }
                    setIsSwitching(true);
                    try {
                      const res = await dispatch(
                        switchUser({ branch_id: branch.id }),
                      );
                      if (res.meta.requestStatus === "fulfilled") {
                        setTimeout(() => {
                          window.location.href = "/manager/dashboard";
                        }, 500);
                      } else {
                        setIsSwitching(false);
                      }
                    } catch (error) {
                      console.error("Switch failed:", error);
                      setIsSwitching(false);
                    }
                    setTimeout(() => setIsSwitching(false), 5000);
                  },
                  className: isCurrentBranch ? "current-branch" : "",
                  template: (item, options) => {
                    if (!item) return null;

                    return (
                      <button
                        onClick={(e) => options?.onClick?.(e)}
                        className={classNames(
                          options?.className || "",
                          "w-full p-link flex items-center py-2 px-3 text-color rounded-none",
                          isCurrentBranch
                            ? "bg-gray-200 font-medium"
                            : "hover:bg-gray-100",
                        )}
                        disabled={isCurrentBranch}
                      >
                        <i
                          className={`${item.icon || "pi pi-building"} mr-2`}
                        ></i>
                        <span className="flex-1 text-left">
                          {item.label || "Branch"}
                        </span>
                        {isCurrentBranch && (
                          <span className="text-xs ml-2">
                            ({t("Current")})
                          </span>
                        )}
                      </button>
                    );
                  },
                };
              })
              .filter(Boolean)
            : []),
        ]}
        popup
        ref={branchMenu}
        id="popup_branch_menu"
        className="!bg-white text-black border border-gray-200 shadow-lg custom-menu"
        pt={{
          label: { className: "text-black" },
          content: { className: `!bg-white` },
          icon: { className: "text-gray-700" },
        }}
        style={{ width: "16rem" }}
      />

      <SharedConfirmDialog
        visible={logoutConfirm}
        setVisible={setLogoutConfirm}
        message="Doyouwanttologout?"
        rejectLabel="No"
        acceptLabel="Yes"
        onAccept={() => {
          localStorage.clear();
          dispatch(logout());
          navigate("/login");
        }}
        onReject={() => setLogoutConfirm(false)}
      />
    </nav>
  );
}
